/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientInsurance } from './PatientInsurance';
import {
    PatientInsuranceFromJSON,
    PatientInsuranceFromJSONTyped,
    PatientInsuranceToJSON,
} from './PatientInsurance';

/**
 * 
 * @export
 * @interface PatientInfo
 */
export interface PatientInfo {
    /**
     * Patient first name
     * @type {string}
     * @memberof PatientInfo
     */
    first_name: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof PatientInfo
     */
    last_name: string;
    /**
     * Patient date of birth
     * @type {string}
     * @memberof PatientInfo
     */
    dob: string;
    /**
     * Patient gender
     * @type {string}
     * @memberof PatientInfo
     */
    gender?: string;
    /**
     * 
     * @type {Array<PatientInsurance>}
     * @memberof PatientInfo
     */
    insurances: Array<PatientInsurance>;
}

/**
 * Check if a given object implements the PatientInfo interface.
 */
export function instanceOfPatientInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "dob" in value;
    isInstance = isInstance && "insurances" in value;

    return isInstance;
}

export function PatientInfoFromJSON(json: any): PatientInfo {
    return PatientInfoFromJSONTyped(json, false);
}

export function PatientInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'insurances': ((json['insurances'] as Array<any>).map(PatientInsuranceFromJSON)),
    };
}

export function PatientInfoToJSON(value?: PatientInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'gender': value.gender,
        'insurances': ((value.insurances as Array<any>).map(PatientInsuranceToJSON)),
    };
}

